import React from "react";

const LABELS = {
  draft: "Draft",
  in_review: "In Review",
  approved: "Approved",
  expired: "Expired",
  superseded: "Superseded",
  pending: "Pending",
  rejected: "Rejected",
  changes_requested: "Changes Requested",
};

export function StatusBadge({ status, className = "", ...rest }) {
  const key = (status || "draft").toLowerCase();
  return (
    <span
      className={`status-badge status-${key} ${className}`}
      data-testid={`status-${key}`}
      {...rest}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {LABELS[key] || key}
    </span>
  );
}
